import { ClipLibrary } from "../features/clips";

export default function VideoLibraryPage() {
  return <ClipLibrary />;
}
